import Action from '../action';
import { Filter } from './FilterTypes';

export class FiltersState {
    relatedTo: string;
    selectedFilters: Filter[];

    constructor(selectedFilters: Filter[], relatedTo: string) {
        this.selectedFilters = selectedFilters;
        this.relatedTo = relatedTo;
    }
}

export enum FiltersTypes {
    beneficiaries = 'beneficiaries',
    transactions = 'transactions',
    activityLogs = 'activity-logs',
    summaryStatistics = 'summary-statistics',
    beneficiaryZeroing = 'beneficiary-zeroing',
}

export const ActionTypes = {
    saveFilters: 'FiltersStore.saveFilters',
};

export const FiltersCreators = {
    saveFilters(filters: Filter[], relatedTo: string) {
        return (dispatch) => {
            return dispatch({
                type: ActionTypes.saveFilters,
                payload: {
                    relatedTo: relatedTo,
                    filters: filters,
                },
            });
        };
    },
};

export function filtersReducer(state: FiltersState[] = [], action: Action): FiltersState[] {
    switch (action.type) {
        case ActionTypes.saveFilters: {
            const filtersPayload = action.payload as { relatedTo: string; filters: Filter[] };
            if (state && !state.find((x) => x.relatedTo === filtersPayload.relatedTo)) {
                return state.concat(new FiltersState(filtersPayload.filters, filtersPayload.relatedTo));
            }

            if (state.length < 1) {
                return [new FiltersState(filtersPayload.filters, filtersPayload.relatedTo)];
            }
            const index = state.findIndex((x) => x.relatedTo === filtersPayload.relatedTo);
            if (!~index) {
                return state.concat([new FiltersState(filtersPayload.filters, filtersPayload.relatedTo)]);
            }

            state.splice(index, 1, new FiltersState(filtersPayload.filters, filtersPayload.relatedTo));
            return state;
        }
    }
    return state;
}
